angular.module('hcap-analytics')
.controller('CohortsCtrl', [
  '$scope',
  'CohortsService',
  '$uibModal',
  '$state',
function(
  $scope,
  CohortsService,
  $uibModal,
  $state,
) {
  const portal = $state.params.portal;

  $scope.portal = portal;

  $scope.data = {
    cohorts: [],
    introHide: true,
  };

  const setup = force => {
    return CohortsService.getByPortal(portal, force).then(cohorts => {
      $scope.data.cohorts = cohorts;
    });
  };

  setup();

  $scope.onCreate = () => {
    $uibModal.open({
      templateUrl: 'templates/partials/_createCohort.html',
      controller: ['$uibModalInstance', '$scope', ($uibModalInstance, $scope) => {
        $scope.data = {
          form: null,
          name: null,
        };

        $scope.submit = () => {
          $scope.data.form.$setSubmitted();

          if ($scope.data.form.$valid) {
            const cohort = {
              name: $scope.data.name,
              timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
              portal,
            };

            CohortsService.createCohort(cohort).then(() => {
              setup(true);
              $uibModalInstance.close();
            });
          } else {
            document.querySelector('#modal-body form').reportValidity();
          }
        };

        $scope.close = () => {
          $uibModalInstance.dismiss('cancel');
        };
      }],
    });
  };

  $scope.onDelete = cid => {
    return CohortsService.deleteCohort(cid).then(() => {
      return setup();
    });
  };

  $scope.onUpdate = cid => {
    const cohort = _.cloneDeep($scope.data.cohorts.find(c => c._id === cid));
    const onDelete = $scope.onDelete;

    $uibModal.open({
      templateUrl: 'templates/partials/_updateCohort.html',
      controller: ['$uibModalInstance', '$scope', ($uibModalInstance, $scope) => {
        $scope.data = {
          form: null,
          cohort,
        };

        $scope.submit = () => {
          if ($scope.data.form.$valid) {
            $scope.data.form.$setSubmitted();

            CohortsService.updateCohort(cohort).then(() => {
              setup();
              $uibModalInstance.close();
            });
          } else {
            document.querySelector('input').reportValidity();
          }
        };

        $scope.deleteCohort = () => {
          onDelete(cid).then($uibModalInstance.close);
        };

        $scope.close = () => {
          $uibModalInstance.dismiss('cancel');
        };
      }],
    });
  };

  $scope.toggleIntro = () => {
    $scope.data.introHide = !$scope.data.introHide;
  };

}]);
